<template>
    <nav>
      <v-app-bar color="white" dense clipped-left elevate-on-scroll app>
      <img @click="gohomelanding" src="../assets/logoirsmarket1.png" class="logox" height="36" alt="irsmarket">
      <v-toolbar-title class="white--text logotitle"></v-toolbar-title>
      <v-spacer></v-spacer>
        <v-toolbar-items v-if="!user.verifyphone && accountlengkap">
         <v-btn elevation="0" @click.native="setdialogverifyhp(true)" dark class="warning white--text text--white" color="warning">Verifikasi No HP</v-btn>
        </v-toolbar-items>
      <v-toolbar-items class="hidden-xs-only">
        <v-btn v-if="accountlengkap" @click="setdialogtopupsaldo(true)" color="primary" text>
          <v-img width="20px" src="../assets/iconisisaldo.png"></v-img>
          Topup</v-btn>
        <v-btn v-if="isseller && accountlengkap" @click="setdialogcashout(true)" color="primary" text>
          <v-img width="20px" src="../assets/icontarikdana.png"></v-img>
          Cashout</v-btn>
        <v-btn v-if="accountlengkap" @click="gohistori" color="primary" class="hidden-xs-only" text>
          <v-icon class="mr-1">account_balance_wallet</v-icon>
          {{formatAngka(balance)}}</v-btn>
      </v-toolbar-items>
      <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
        <template v-slot:activator="{ on }">
        <v-btn large text slot="activator" v-on="on">
          <v-avatar class="mr-2" size="30px">
            <img v-if="user.member.memberavatar" :src="user.member.memberavatar" alt="iconmember">
            <img v-else src="../assets/irsicon.jpg" alt="iconmember">
          </v-avatar>
          {{ user.member.membername }}
        </v-btn>
        </template>
        <v-list class="pa-0">
          <v-list-item
            v-for="(item,index) in items"
            :to="!item.href ? { name: item.name } : null"
            :href="item.href"
            @click="item.click"
            ripple="ripple"
            :class="item.class"
            :disabled="item.disabled"
            :target="item.target"
            rel="noopener"
            :key="index"
          >
            <v-list-item-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </nav>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import Utils from '@/plugins/utils'

export default {
  name: 'app-toolbar',
  data: () => ({
    dialog: false,
    valid: true,
    cancel: true,
    intervalceksaldo: '',
    localuser: {
      member: {
        memberbalance: 0
      }
    },
    initdata: true,
    maintenance_switch2: false,
    push: { title: '', msg: '' },
    items: [
      {
        icon: 'account_circle',
        href: '#',
        title: 'Topup Saldo',
        class: 'hidden-lg-only',
        click: e => {
          window.getApp.$emit('APP_TOPUPSALDO')
        }
      },
      {
        icon: 'account_circle',
        href: '#',
        title: 'Profile',
        click: e => {
          window.getApp.$emit('APP_PROFILE')
        }
      },
      {
        icon: 'settings',
        href: '#',
        title: 'Change Password',
        click: () => {
          window.getApp.$emit('APP_CHANNGE_PASSWORD')
        }
      },
      {
        icon: 'fullscreen_exit',
        href: '#',
        title: 'Logout',
        click: () => {
          window.getApp.$emit('APP_LOGOUT')
        }
      }
    ]
  }),
  computed: {
    ...mapState('authentication', ['user', 'isseller', 'accountlengkap']),
    ...mapState('UserStore', ['balance', 'dialogverifikasihp'])
  },
  beforeDestroy () {
    clearInterval(this.intervalceksaldo)
  },
  watch: {
  },
  mounted () {
    this.localuser = JSON.parse(localStorage.getItem('user'))
    this.cekBalance()
  },
  methods: {
    ...mapActions('SaldoStore', ['setdialogtopupsaldo', 'setdialogcashout']),
    ...mapActions('UserStore', ['getBalance', 'setdialogverifyhp']),
    cekBalance: function () {
      const self = this
      this.getBalance()
      this.intervalceksaldo = setInterval(function () {
        console.log('Cek Balance')
        self.getBalance()
      }, 120000)
    },
    formatAngka (val) {
      return Utils.formatAngka(val)
    },
    gohistori () {
      this.$router.push('/histori')
    },
    gohomelanding () {
      // this.$router.push('https://irsmarket.com')
    },
    handleDrawerToggle () {
      window.getApp.$emit('APP_DRAWER_TOGGLED')
    },
    getUserLocal () {
    },
    openformpush () {
      this.dialog = true
    },
    closeform () {
      this.dialog = false
    },
    sendpush (data) {
      this.$store.dispatch('InfoStore/sendPush', data)
      this.push.title = ''
      this.push.msg = ''
      this.dialog = false
    }
  }
}
</script>

<style>
.logotitle {
  margin-left: 8px;
}
.logox {
  margin-left: 8px;
}
</style>
